import { useState } from 'react';
import { Sheet } from './ui/Sheet.js';
import { Button } from './ui/Button.js';
import { useT } from '../i18n/index.js';

// TODO: wire to real feedback endpoint once added to cloud API
export function FeedbackWidget() {
  const t = useT();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [sent, setSent] = useState(false);

  const submit = () => {
    // Placeholder — in v1 we just show a thank-you; no endpoint yet.
    setSent(true);
    setTimeout(() => {
      setOpen(false);
      setSent(false);
      setText('');
    }, 1200);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-20 right-4 md:bottom-6 z-40 px-4 py-2 rounded-full shadow-lg border text-sm"
        style={{
          backgroundColor: 'var(--ac-surface-elevated)',
          borderColor: 'var(--ac-border)',
          color: 'var(--ac-text)',
        }}
      >
        💬 {t('feedback.button')}
      </button>
      <Sheet open={open} onClose={() => setOpen(false)} title={t('feedback.button')}>
        {sent ? (
          <p className="text-[var(--ac-success)]">{t('feedback.thanks')}</p>
        ) : (
          <div className="flex flex-col gap-3">
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder={t('feedback.placeholder')}
              className="w-full min-h-24 p-3 rounded-lg border text-sm"
              style={{
                backgroundColor: 'var(--ac-bg)',
                borderColor: 'var(--ac-border)',
                color: 'var(--ac-text)',
              }}
            />
            <div className="flex justify-end gap-2">
              <Button variant="ghost" onClick={() => setOpen(false)}>
                {t('common.cancel')}
              </Button>
              <Button onClick={submit} disabled={!text.trim()}>
                {t('feedback.submit')}
              </Button>
            </div>
          </div>
        )}
      </Sheet>
    </>
  );
}
